import { AlertCircle, CheckCircle } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'

type LanguageUpdatedResult = {
  previousLanguage: string
  newLanguage: string
  success: boolean
}

type Props = {
  result: LanguageUpdatedResult | null | undefined
}

export function LanguageUpdatedCard({ result }: Props) {
  const t = useTranslation()

  if (!result) return null

  if (!result.success) {
    return (
      <div className="bg-card border border-destructive/50 rounded-xl p-3 my-1.5 flex items-center gap-2">
        <AlertCircle className="w-4 h-4 text-destructive shrink-0" />
        <span className="text-sm text-destructive">
          {t('agent.tools.language.failed', { from: result.previousLanguage, to: result.newLanguage })}
        </span>
      </div>
    )
  }

  return (
    <div className="bg-card border border-border rounded-xl p-3 my-1.5 flex items-center gap-2">
      <CheckCircle className="w-4 h-4 text-success shrink-0" />
      <span className="text-sm text-card-foreground">
        {t('agent.tools.language.changed')} <strong>{result.previousLanguage}</strong> {t('agent.tools.language.to')}{' '}
        <strong>{result.newLanguage}</strong>
      </span>
    </div>
  )
}
